import {
  API_GO_DOCS_RECORD_BY_ID,
  API_GO_DOCS_RECORDS,
} from 'config'
import Api from 'services/api'

export const getGoDocsRecords = () => {
  return Api.get(API_GO_DOCS_RECORDS)
}

export const createGoDocsRecord = (overrideValues?: Record<string, string>) => {
  return Api.post(API_GO_DOCS_RECORDS, { overrideValues }, {}, { timeout: 180000 })
}

export const getGoDocsRecordById = (id: number) => {
  return Api.get(API_GO_DOCS_RECORD_BY_ID, {}, { id })
}

export const deleteGoDocsRecord = (id: number) => {
  return Api.delete(API_GO_DOCS_RECORD_BY_ID, {}, { id })
}
